exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".help[data-v-81178bf6]{font-family:Roboto,sans-serif;line-height:1.9rem;padding:25px 40px 0!important;font-size:.9rem}.help section[data-v-81178bf6]{margin-bottom:3rem}.help h2[data-v-81178bf6],.help h3[data-v-81178bf6]{font-family:Sumana,serif;padding-bottom:8px}.help h3[data-v-81178bf6]{font-size:1.5rem;border-bottom:1px solid #e46a3b;margin-bottom:1.4rem}.help h3 i[data-v-81178bf6]{width:30px;margin-right:.5rem}.help p[data-v-81178bf6]{margin-bottom:1.5rem}.help h6 i[data-v-81178bf6]{margin-right:6px}.help li i[data-v-81178bf6],.help p i[data-v-81178bf6],.help td i[data-v-81178bf6]{margin:0 4px}.help ol li[data-v-81178bf6],.help ul li[data-v-81178bf6]{margin-bottom:15px;line-height:normal}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-81178bf6","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/app/builder/help.vue
// module id = 439
// module chunks = 0